export default {
  'globalHeader.avatar.changePwd': 'Change Password',
  'globalHeader.changePwd.title': 'Change Password',
  'globalHeader.changePwd.oldPassword': 'Old Password',
  'globalHeader.changePwd.oldPassword.required': 'Please enter old password',
  'globalHeader.changePwd.newPassword': 'New Password',
  'globalHeader.changePwd.newPassword.required': 'Please enter new password',
  'globalHeader.changePwd.newPassword.sameAsOld':
    'New password must differ from the old password',
  'globalHeader.changePwd.confirmPassword': 'Confirm Password',
  'globalHeader.changePwd.confirmPassword.required':
    'Please enter the new password again',
  'globalHeader.changePwd.confirmPassword.mismatch':
    'The two new passwords do not match',
  'globalHeader.changePwd.success': 'Password changed, please log in again',
};
